// extracted by mini-css-extract-plugin
export default {"badges":"badges--t5LTC","badge--sm":"badge--sm--1mIzO","badge--md":"badge--md--D6vuy","tooltip__id":"tooltip__id--ipfWe","tooltip__description":"tooltip__description--2cWwL","tooltip__date":"tooltip__date--3D8RC"};
    if(module.hot) {
      // 1747648185404
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  